module.exports = __webpack_public_path__ + "static/img/apply_bg.68818b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/apply_bg.png
// module id = Px4u
// module chunks = 1